import { DeepPartial } from 'ts-essentials';

import {
  DocumentTypeEnum,
  FraudAnalysisVendorEnum,
  WorkspaceSettingsDocumentModel,
} from '../../../../shared/models';
import yup from '../../../../utils/yup-extended';

const fraudAnalysisWorkspaceSettingsSchema = yup
  .object()
  .shape({
    enabled: yup.boolean().defined(),
    vendor: yup
      .mixed()
      .oneOf([null, ...Object.values(FraudAnalysisVendorEnum)])
      .nullable(),
  })
  .optional();

export const workspaceSettingsDocumentFraudAnalysisSchema = (): yup.SchemaOf<
  WorkspaceSettingsDocumentModel['fraudAnalysis']
> =>
  yup
    .object()
    .required()
    .shape({
      [DocumentTypeEnum.proof_of_address]: fraudAnalysisWorkspaceSettingsSchema,
      [DocumentTypeEnum.registration_certificate]:
        fraudAnalysisWorkspaceSettingsSchema,
      [DocumentTypeEnum.bank_details]: fraudAnalysisWorkspaceSettingsSchema,
    })
    .default({})
    .strict();

export const validateWorkspaceSettingsDocumentFraudAnalysis = (
  fraudAnalysis: DeepPartial<
    WorkspaceSettingsDocumentModel['fraudAnalysis']
  > = {},
): void => {
  workspaceSettingsDocumentFraudAnalysisSchema().validateSync(fraudAnalysis, {
    abortEarly: false,
  });
};
